module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-new-entry-point"
  }, [_c('transition', {
    attrs: {
      "name": "cep-overlay-fade"
    }
  }, [(_vm.showGuide) ? _c('div', {
    staticClass: "cep-drawer-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showGuide = false
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "cep-drawer-slide"
    }
  }, [(_vm.showGuide) ? _c('div', {
    staticClass: "cep-guide-drawer"
  }, [_c('div', {
    staticClass: "cep-drawer-header"
  }, [_c('div', [_c('h2', {
    staticClass: "cep-drawer-title"
  }, [_vm._v("Entry point guide")]), _vm._v(" "), _c('p', {
    staticClass: "cep-drawer-subtitle"
  }, [_vm._v("\n            Read-only reference — does not affect the chat\n          ")])]), _vm._v(" "), _c('button', {
    staticClass: "cep-drawer-close",
    on: {
      "click": function($event) {
        _vm.showGuide = false
      }
    }
  }, [_vm._v("\n          ×\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "cep-drawer-body"
  }, [_c('div', {
    staticClass: "cep-guide-example"
  }, [_c('div', {
    staticClass: "cep-guide-example-label"
  }, [_vm._v("ONE-SHOT EXAMPLE")]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-example-text"
  }, [_vm._v("\n            \"WhatsApp + Messenger, MyDawa Kenya, contraceptive campaign\n            targeting women 18–25. CTA: Get confidential guidance now. Land\n            users at the contraceptive selection stage.\"\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-section-title"
  }, [_vm._v("\n          MANDATORY — AI ALWAYS COLLECTS\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item"
  }, [_c('span', {
    staticClass: "cep-guide-dot"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              Ad creative or context\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-first"
  }, [_vm._v("First")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("\n              Upload image or describe context. Used to infer programme,\n              journey, and generate messaging.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item"
  }, [_c('span', {
    staticClass: "cep-guide-dot"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              Customer / Client\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-required"
  }, [_vm._v("Required")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("\n              AI asks early in chat. Determines which journey defaults and\n              journeys are loaded.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item"
  }, [_c('span', {
    staticClass: "cep-guide-dot"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              Channel(s)\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-required"
  }, [_vm._v("Required")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("\n              WhatsApp, Messenger, or LINE. Inferred from context where\n              possible.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item"
  }, [_c('span', {
    staticClass: "cep-guide-dot"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              Journey + Stage\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-required"
  }, [_vm._v("Required")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("\n              Describe naturally. AI resolves via Country › Customer folder\n              structure.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item"
  }, [_c('span', {
    staticClass: "cep-guide-dot"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              Phrase\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-required"
  }, [_vm._v("Required")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("\n              AI suggests from ad context. Min 1. WA: 1,024 / MS: 640 / LINE:\n              2,000 chars.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item"
  }, [_c('span', {
    staticClass: "cep-guide-dot"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              Welcome message (all languages)\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-required"
  }, [_vm._v("Required")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("\n              AI generates per active language. Must confirm before output\n              generation.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-section-title cep-section-blue"
  }, [_vm._v("\n          AUTO-APPLIED FROM JOURNEY DEFAULTS\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item cep-item-blue"
  }, [_c('span', {
    staticClass: "cep-guide-dot cep-dot-blue"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              Onboarding mode, NLP question, Auto-accept T&C, Club Optin,\n              Default gender, Referral priority, Ownership/Physical/Medical\n              filters\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-silent"
  }, [_vm._v("Silent")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("\n              Retrieved from Journey defaults and applied without asking.\n              Shown in confirmation summary. Override in chat.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-section-title cep-section-orange"
  }, [_vm._v("\n          CAMPAIGN METADATA — ASKED ONCE AT THE END\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item cep-item-orange"
  }, [_c('span', {
    staticClass: "cep-guide-dot cep-dot-orange"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              Keyword Use, Keyword Topic, Campaign, Campaign Code, UTM Source,\n              UTM Medium\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-optional"
  }, [_vm._v("Optional")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("\n              AI asks once at the end: \"Do you want to add campaign metadata?\"\n              User can fill in or skip entirely.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-section-title cep-section-gray"
  }, [_vm._v("\n          OPTIONAL — IN OUTPUT PANEL\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item cep-item-gray"
  }, [_c('span', {
    staticClass: "cep-guide-dot cep-dot-gray"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              Custom short URL\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-optional-gray"
  }, [_vm._v("Optional")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("\n              Override auto-generated slug. Warning shown: changing this\n              updates the QR code.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cep-guide-item cep-item-gray"
  }, [_c('span', {
    staticClass: "cep-guide-dot cep-dot-gray"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "cep-guide-item-header"
  }, [_vm._v("\n              QR code logo\n              "), _c('span', {
    staticClass: "cep-badge cep-badge-optional-gray"
  }, [_vm._v("Optional")])]), _vm._v(" "), _c('p', {
    staticClass: "cep-guide-item-desc"
  }, [_vm._v("Toggle Nivi logo. Default off.")])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "cep-overlay-fade"
    }
  }, [(_vm.showNewChatDialog) ? _c('div', {
    staticClass: "cep-dialog-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showNewChatDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "cep-dialog"
  }, [_c('h4', {
    staticClass: "cep-dialog-title"
  }, [_vm._v("Start a new chat?")]), _vm._v(" "), _c('p', {
    staticClass: "cep-dialog-body"
  }, [_vm._v("Your current conversation will be saved and a fresh chat will begin.")]), _vm._v(" "), _c('div', {
    staticClass: "cep-dialog-actions"
  }, [_c('button', {
    staticClass: "cep-dialog-btn cep-dialog-btn-cancel",
    on: {
      "click": function($event) {
        _vm.showNewChatDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "cep-dialog-btn cep-dialog-btn-confirm",
    on: {
      "click": _vm.confirmNewChat
    }
  }, [_vm._v("Yes")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cep-body"
  }, [_c('div', {
    staticClass: "cep-left-column"
  }, [_c('div', {
    staticClass: "cep-topbar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cep-topbar-actions"
  }, [_c('button', {
    staticClass: "cep-new-chat-btn",
    on: {
      "click": function($event) {
        _vm.showNewChatDialog = true
      }
    }
  }, [_vm._v("\n            + New Chat\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "cep-guide-btn cep-export-btn",
    on: {
      "click": _vm.printChat
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "cep-guide-btn",
    on: {
      "click": function($event) {
        _vm.showGuide = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" Guide\n          ")])])]), _vm._v(" "), (!_vm.chatReady) ? _c('div', {
    staticClass: "cep-chat-loading"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.showChat) ? _c('chat-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chatReady),
      expression: "chatReady"
    }],
    ref: "chatPanel",
    on: {
      "ready": function($event) {
        _vm.chatReady = true
      },
      "entry-point-created": _vm.onEntryPointCreated
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "cep-output cep-output-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" "), _c('span', [_vm._v("Loading entry point…")])]) : _c('output-sidebar', {
    staticClass: "cep-output",
    attrs: {
      "output": _vm.entryPointOutput
    },
    on: {
      "save": _vm.onOutputSave,
      "output_panel_edit": function (p) { return _vm.onOutputEvent('output_panel_edit', p); },
      "output_copied": function (p) { return _vm.onOutputEvent('output_copied', p); },
      "output_downloaded": function (p) { return _vm.onOutputEvent('output_downloaded', p); },
      "short_url_change_warned": function (p) { return _vm.onOutputEvent('short_url_change_warned', p); },
      "short_url_change_confirmed": function (p) { return _vm.onOutputEvent('short_url_change_confirmed', p); },
      "short_url_change_cancelled": function (p) { return _vm.onOutputEvent('short_url_change_cancelled', p); }
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cep-topbar-info"
  }, [_c('h4', {
    staticClass: "cep-topbar-title"
  }, [_vm._v("Contextual Entry Console")]), _vm._v(" "), _c('p', {
    staticClass: "cep-topbar-subtitle"
  }, [_vm._v("\n            Share your ad creative or describe the context — AI configures your\n            entry point\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cep-chat-loading-inner"
  }, [_c('div', {
    staticClass: "cep-chat-spinner"
  }), _vm._v(" "), _c('span', {
    staticClass: "cep-chat-loading-text"
  }, [_vm._v("Setting up your chat…")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2008861a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/entry-points/create-new-entry-point/CreateNewEntryPoint.vue
// module id = RoYG
// module chunks = 1